module.exports = __webpack_public_path__ + "static/media/ph.ba51f2ba.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ph.svg
// module id = 1135
// module chunks = 0